var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}]},[(
      _vm.routerName === 'Login' ||
      _vm.routerName === 'RecoverPassword' ||
      _vm.routerName === 'ResetPasswordFirtsTime' ||
      _vm.routerName === 'RegisterPublic'
    )?_c('HeaderLogin',{attrs:{"isDefault":_vm.isDefault,"club":_vm.club}}):_vm._e(),_c('router-view'),(_vm.footerShow)?_c('Footer',{attrs:{"isDefault":_vm.isDefault,"club":_vm.club}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }